import * as React from 'react';
import { useState } from 'react';
import { Link} from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import atlasApi from "../utils/atlasapi";
import {formatDate} from "../utils/functions";

import DataTable, { createTheme } from 'react-data-table-component';


createTheme(
	'vlist',
	{
		background: {
			default: 'transparent',
		},
		headRow: {

		}
	},
	'light',
);

		
class DialogViewNotes extends React.Component {
	
	state = {
		data: [],
		pending: true
	};	
	
	constructor(props) {
		super(props);
	}


	handleClose(data){
		this.props.onClose(data);
		this.setState({ data: [], pending:true });
	};
	handleOnShow(e){
//		atlasApi.getScenarioVersions(this.props.scenario.projectid, this.props.scenario.scenario_id).then((data)=>{
//
//			this.setState({ data: data, pending:false });
//
//			this.forceUpdate();
//		}).catch((e)=>{
//			
//		});
		
		
	};



	render() {
		
	
		
		return (
			<Modal className="list-notes" show={!!this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Project Notes</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				
						{!!(this.props.project.notes && this.props.project.notes.length) && 
						<Row className="owner-dialog mb-3">

							{
								
								this.props.project.notes.map((note, j)=>{
									var d = formatDate(note.date, 'natural');
									
									
									return (
										<React.Fragment key={j}>
											<div className="msg-wrp">
												<div className="msg-body">
													<small>{note.username}</small>
													{note.note}
													<small>{d}</small>
												</div>
											</div>
										</React.Fragment>
									)
								})
							}
							
			

						</Row> 
						}
						{(!this.props.project.notes || !this.props.project.notes.length) && <Row className="owner-dialog mb-3"><div className="msg-wrp"><Alert variant="warning">
						This project doesn't have notes
						</Alert></div></Row>}
						<div className="text-end">
							<Button variant="success" size="sm" onClick={()=>{this.handleClose(); this.props.onAdd({open:true});}}>Add Note</Button>
						</div> 
				
				
				</Modal.Body>
				<Modal.Footer>
					<Button className="me-auto" variant="secondary" onClick={(e)=>this.handleClose()}>Close</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default DialogViewNotes;